export default "__VITE_ASSET__DjfQeudM__"